import {
  Component,
  OnInit,
  OnDestroy,
  Input,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DashboardService } from "../dashboard.service";
import { ModalService } from "../modal.service";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { AttachmentPopupComponent } from "../attachment-popup/attachment-popup.component";
import { TranslateService } from "@ngx-translate/core";
import { HttpErrorResponse } from "@angular/common/http";
import { SharedService } from "src/app/shared/shared.service";
import { ViewAttachmentComponent } from "../view-attachment/view-attachment.component";
import { ConnectionService } from "../connection.service";
import { UploadFileComponent } from "../upload-file/upload-file.component";
export class PageParams {
  patient: string;
  tag: string;
  size: number;
  skip: number;
}

export interface Document {
  _id: string;
  url: string;
  name: string;
  patient: string;
  parent: string;
  status: number;
  createdAt: Date;
  updatedAt: Date;
  id: string;
}

export enum extDocuments {
  pdf = "pdf",
  doc = "doc",
  docx = "docx",
  xls = "xls",
  xlsx = "xlsx",
  csv = "csv",
  jpg = "jpg",
  jpeg = "jpeg",
  png = "png",
}

@Component({
  selector: "app-attachments",
  templateUrl: "./attachments.component.html",
  styleUrls: ["./attachments.component.scss"],
})
export class AttachmentsComponent implements OnInit, OnDestroy {
  @Input() canAdd: boolean;
  totalLength: boolean = false;
  tags: any = [];
  docsList: any = [];
  docListLength: number = 0;
  documentFilter: any = [];
  pageParams: Partial<PageParams> = { size: 10, skip: 0 };
  tagId: any = [];
  patientId;
  patientDetials: any;
  filterId;
  filterAttachement = false;
  loading: boolean = true;
  attachmentInCall: boolean = false;
  callStatus: boolean = false;
  tagSequence = [];
  callFeedbackSubscription: Subscription;
  currentLanguage: string = "es";
  sockectSubscription: Subscription;
  public attachmentOnCallRecord: any;
  extDocuments = extDocuments;
  dialogRef: any = null;

  constructor(
    public dialog: MatDialog,
    private dashboardService: DashboardService,
    private route: ActivatedRoute,
    private modalService: ModalService,
    private translateService: TranslateService,
    private sharedService: SharedService,
    private connectionService: ConnectionService,
  ) {}
  
  ngOnInit() {
    this.connectionService.connect();
    this.getallTags();

    if ( this.translateService.currentLang == "en-US" ) {
      this.currentLanguage = "en";
    }

    this.callFeedbackSubscription = this.modalService.callFeedBackObservable.subscribe((res) => {
      if (res.callStatus == 2) {
        this.callStatus = false;
        if (this.sockectSubscription) {
          this.sockectSubscription.unsubscribe();
        }
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.patientId = params.patient;
      this.getPatientDetails(this.patientId);
      this.docsList = [];
      this.pageParams.skip = 0;
      this.getDocuments();
    });

    this.modalService.vscallStatusObservable.subscribe((res) => {
      if (res.callStarted) {
        this.callStatus = true;
        this.sockectSubscription = this.connectionService.messages.subscribe({
          next: (msg) => {
            if (msg.data.url) {
              this.attachmentOnCallRecord = msg["data"];
              this.viewAttachment();
            }
          },
        });
      }
    });
  }

  viewAttachment() {
    
    if ( this.dialogRef ) {
      this.dialogRef.close();
    };

    this.dialogRef = this.dialog.open(ViewAttachmentComponent, {
      width: "402px",
      disableClose: true,
      data: { record: this.attachmentOnCallRecord },
    });

    this.dialogRef.afterClosed().subscribe((_) => {
      this.dialogRef = null;
      this.docsList = [];
      let replace = true;
      this.pageParams.skip = 0;
      this.pageParams.tag = "";
      this.getDocuments(replace);
    });
  }

  attachmentPopup(attachment) {
    
    if ( this.dialogRef ) {
      this.dialogRef.close();
    }

    this.dialogRef = this.dialog.open(AttachmentPopupComponent, {
      width: "600px",
      panelClass: "attachment-popup-dialog",
      data: { document: attachment._id, status: this.callStatus },
    });

    this.dialogRef.afterClosed().subscribe((_) => {
      this.dialogRef = null;
      this.docsList = [];
      let replace = true;
      this.pageParams.skip = 0;
      this.pageParams.tag = "";
      this.getDocuments(replace);
    });
  }

  getallTags() {
    this.dashboardService.getTags().subscribe({
      next: (res: any) => {
        this.tags = res["data"];
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  documentsGetImage(data: Document) {
    try {
      const bucketName = "sinapsis-dev.s3.us-east-1";
      if (!data.url.split(".com")[0].includes(bucketName)) {
        data.url =
          "https://sinapsis-dev.s3.us-east-1.amazonaws.com/" + data.url;
      }

      const { pathname } = new URL(data.url);
      const imageExtension = pathname.split(".").pop().toLowerCase();
      const obj = {
        ...data,
        url: data.url,
      };
      
      if ( ["jpg", "jpeg"].includes(imageExtension) )  {
        obj['ext'] = extDocuments.jpg;
      } else if ( ["png"].includes(imageExtension) ) {
        obj['ext'] = extDocuments.png;
      } else if ( ["xls", "xlsx", "csv"].includes(imageExtension) ) {
        obj['ext'] = extDocuments.xls;
      } else if ( ["doc", "docx"].includes(imageExtension) ) {
        obj['ext'] = extDocuments.doc;
      } else {
        obj['ext'] = extDocuments.pdf;
      }

      return obj;
    } catch (e) {
      this.handleError(e);
    }
  }

  getDocumentsFilter(data) {
    console.log(data, "data");
    this.pageParams.tag = data ? data : "";
    this.pageParams.skip = 0;
    let replace = true;
    this.getDocuments(replace);
  }

  pagination() {
    this.pageParams.skip = this.pageParams.skip + 10;
    this.getDocuments();
  }

  getDocuments(replace?: boolean) {
    this.pageParams.patient = this.patientId;
    if(!this.pageParams.tag) {
      delete this.pageParams.tag;
    }
    

    this.dashboardService.getDocuments(this.pageParams as any).subscribe({
      next: (res: any) => {
        if ( replace ) {
          this.docsList = res.data.map((doc: Document) =>
            this.documentsGetImage(doc),
          );
        } else {
          this.docsList.push(...res.data.map((doc: Document) =>
            this.documentsGetImage(doc),
          ));
        }
        if ( this.docsList.length == res.meta.total ) {
          this.totalLength = true;
        }
        else {
          this.totalLength = false;
        }
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
        this.loading = false;
      },
    });
  }

  getPatientDetails(patientId) {
    this.dashboardService.getPatientDetials(patientId).subscribe({
      next: (res: any) => {
        this.patientDetials = res;
      },
      error: (error: HttpErrorResponse) => {
        this.handleError(error);
      },
    });
  }

  uploadFile() {
    const uploadRef = this.dialog.open(UploadFileComponent, {
      width: "600px",
      disableClose: true,
      autoFocus: false,
      data: {
        patientDetials: this.patientDetials,
      },
    });

    uploadRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        switch (result.event) {
          case "refreshList":
            this.getDocuments(true);
            break;
        }
      }
    });
  }

  ngOnDestroy() {
    this.callFeedbackSubscription.unsubscribe();
    if (this.sockectSubscription) {
      this.sockectSubscription.unsubscribe();
    }
  }

  handleError(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = error.error.message;
      this.sharedService.showErrorMessage(errorMessage, "single");
    } else {
      // server-side error

      if (error.status == 422) {
        let values = [];
        for (let key in error.error.errors.messages) {
          values.push(error.error.errors.messages[key]);
        }
        this.sharedService.showMultipleErrors(values, "multi");
      } else {
        if (typeof error.error.errors == "object") {
          errorMessage = error.error.errors.messages[0];
        } else {
          errorMessage = error.error.message.join(", ") || error.error;
        }
        this.sharedService.showErrorMessage(errorMessage, "single");
      }
    }
  }
}